import session from "../../core/session.js";

function linkedDocumentService() {
	const that = {};

	that.haveLinkedDocumentIntegration = function () {
		return session.getCompany().hasLinkedDocumentIntegration();
	};

	that.getByLedgerEntry = function (ledgerEntry) {
		return `/Accounting2/Company/${session
			.getCompany()
			.getId()}/LinkedDocument/${ledgerEntry.getFiscalYearId()}/${ledgerEntry.getSeries()}/${ledgerEntry.getNumber()}`;
	};

	return that;
}

export default linkedDocumentService();
